/**
 * © Copyright Union Systems Inc 2026. All rights reserved.
 */

export const ChevronRightIcon = (
  props: React.ComponentPropsWithoutRef<'svg'>,
) => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.705 0L0.294998 1.41L4.875 6L0.294998 10.59L1.705 12L7.705 6L1.705 0Z"
      fill="#71717A"
    />
  </svg>
)
